import { gql } from '@apollo/client';

export const StatusKeys = {
  PROGRESS: 'in-progress',
  NEW: 'new',
  FINISHED: 'finished',
  HOLD: 'on-hold',
};

export const ProjectStatuses = {
  [StatusKeys.PROGRESS]: 'PROGRESS',
  [StatusKeys.NEW]: 'NEW',
  [StatusKeys.FINISHED]: 'FINISHED',
  [StatusKeys.HOLD]: 'HOLD',
};

export const queryGetProjects = gql`
  query ProjectsTableQuery($state: ClientContractStatusEnum!, $company: ID, $term: String) @api(name: admin) {
    contracts(state: $state, company: $company, term: $term) {
      id
      title
      reference
      company {
        id
        title
      }
      primaryContact {
        id
        firstName
        lastName
      }
      assignedEmployeesCount
      ordersCount
      invoicesCount
      lastInvoiced
    }
  }
`;

export const queryGetCompanies = gql`
  query CompaniesQuery($term: String) @api(name: root) {
    companies(term: $term) {
      id
      title
    }
  }
`;

export const queryGetServices = gql`
  query ServicesQuery @api(name: root) {
    services {
      id
      title
    }
  }
`;

export const mutationDeleteProject = gql`
  mutation deleteProjectMutation($ids: [Int]!) @api(name: admin) {
    deleteProject(ids: $ids) {
      deletedCount
    }
  }
`;
